import Marquee from "react-fast-marquee";

const words = ["Calm", "Gentle", "Present", "Balanced", "Mindful", "Unhurried", "Warm", "Whole"];

export const MarqueeStrip = () => (
  <section className="py-16 md:py-24 border-y border-[#2B2B26]/10" data-testid="marquee-section">
    <Marquee speed={40} gradient={false} autoFill>
      {words.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-serif font-light text-5xl sm:text-6xl md:text-7xl text-[#2B2B26] px-8">
            {w}
          </span>
          <span className="text-[#1877F2] text-3xl md:text-4xl">&middot;</span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default MarqueeStrip;
